import { useFulFillmentType } from '@/hooks/useFulFillmentType';
import { mapProduct as mapOpenSearchProduct } from '@/utils/opensearch';

const useMapProduct = () => {
  const { fulfillmentType } = useFulFillmentType();

  const mapProduct = (
    args: Omit<Parameters<typeof mapOpenSearchProduct>[0], 'fulfillmentType'>,
  ) => mapOpenSearchProduct({ ...args, fulfillmentType });

  return { mapProduct };
};

export { useMapProduct };
